var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessTickWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3517_14969)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 0.5C18.6274 0.5 24 5.87242 24 12.4997C24 19.1272 18.6274 24.4996 11.9999 24.4996C5.37261 24.4998 0 19.1272 0 12.4997C0 5.87242 5.37261 0.5 11.9999 0.5ZM6.66127 13.7183L6.65834 13.7155C6.50503 13.5753 6.4226 13.3864 6.41303 13.1942C6.40346 13.0024 6.46674 12.8065 6.60522 12.6519C6.60717 12.6497 6.60893 12.6478 6.61088 12.6458C6.75092 12.4927 6.93979 12.4101 7.13197 12.4005C7.32514 12.3909 7.5222 12.4552 7.67728 12.5954L10.2077 14.8899L16.2798 8.53079C16.4243 8.37923 16.6163 8.30033 16.8108 8.29564C17.0045 8.29076 17.2003 8.3599 17.352 8.50404C17.5038 8.64837 17.5825 8.84095 17.5874 9.03509C17.5922 9.22903 17.5229 9.42512 17.3788 9.57668L10.7966 16.4704C10.7921 16.4751 10.7872 16.4796 10.7823 16.4835C10.6427 16.6231 10.4603 16.6973 10.2749 16.7042C10.0847 16.7114 9.89152 16.6469 9.73898 16.5089L6.66362 13.7202L6.66127 13.7183Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3517_14969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.9998,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTickWhite);
export default __webpack_public_path__ + "static/media/success-tick-white.fc3b500a62648e0f8e57488634f0e093.svg";
export { ForwardRef as ReactComponent };